import { gql } from "@apollo/client";
import { parsedCurrency } from "../../../../utils/mathUtils";

const CREATE_TRAMO = gql`
    mutation createTramo($input: AddTramoInput!){
        createTramo(input: $input) {
            idHonorarioProfesionalAjuste
        }
    }
`;

export default CREATE_TRAMO;

export const adaptAddTramoInput = (data) => {
  const {
    valor,
    id,
    ...restData
  } = data;

  return {
    ...restData,
    valor: parsedCurrency(valor)
  };
};